/**
 * Admin Relations API client.
 * Calls GET /admin/relations, GET /admin/blocks.
 */

import { apiFetch } from "./client";

// ─── Types ───

export type RelationType = "h2h" | "h2a";

export type RelationStatus = "active" | "deleted" | "suspended" | "terminated";

export type AdminRelation = {
  readonly id: string;
  readonly type: RelationType;
  readonly user_a_name: string;
  readonly user_a_email: string;
  readonly user_b_name: string;
  readonly user_b_email: string;
  readonly status: RelationStatus;
  readonly conversation_id: string;
  readonly created_at: string;
};

export type AdminBlock = {
  readonly id: string;
  readonly blocker_name: string;
  readonly blocker_email: string;
  readonly blocked_name: string;
  readonly blocked_email: string;
  readonly created_at: string;
};

type ListRelationsParams = {
  readonly q?: string;
  readonly type?: RelationType;
  readonly status?: RelationStatus;
  readonly limit?: number;
  readonly offset?: number;
};

type ListRelationsResponse = {
  readonly items: AdminRelation[];
  readonly total: number;
};

type ListBlocksParams = {
  readonly blocker_id?: string;
  readonly blocked_id?: string;
  readonly limit?: number;
  readonly offset?: number;
};

type ListBlocksResponse = {
  readonly items: AdminBlock[];
  readonly total: number;
};

// ─── API Calls ───

export async function fetchRelations(
  params: ListRelationsParams,
): Promise<ListRelationsResponse> {
  const sp = new URLSearchParams();
  if (params.q) sp.set("q", params.q);
  if (params.type) sp.set("type", params.type);
  if (params.status) sp.set("status", params.status);
  if (params.limit) sp.set("limit", String(params.limit));
  if (params.offset) sp.set("offset", String(params.offset));
  const qs = sp.toString();
  const res = await apiFetch<{ data: ListRelationsResponse }>(
    qs ? `/admin/relations?${qs}` : "/admin/relations",
  );
  return res.data;
}

export async function fetchBlocks(
  params: ListBlocksParams,
): Promise<ListBlocksResponse> {
  const sp = new URLSearchParams();
  if (params.blocker_id) sp.set("blocker_id", params.blocker_id);
  if (params.blocked_id) sp.set("blocked_id", params.blocked_id);
  if (params.limit) sp.set("limit", String(params.limit));
  if (params.offset) sp.set("offset", String(params.offset));
  const qs = sp.toString();
  const res = await apiFetch<{ data: ListBlocksResponse }>(
    qs ? `/admin/relations/blocks?${qs}` : "/admin/relations/blocks",
  );
  return res.data;
}
